<template>

  <el-dialog

    title="购买讲义导出次数"

    :visible.sync="innerVisible"

    width="420px"

    append-to-body

    @closed="resetState"

  >

    <div v-if="loading" class="pay-loading">加载中...</div>

    <div v-else-if="payStep === 'choose'">

      <p class="pay-tip">免费次数已用完。每成功下载 1 次 Word 或 PDF 扣 1 次。</p>

      <div v-for="item in products" :key="item.id" class="product-row">

        <div class="product-info">

          <div class="product-name">{{ item.name }}</div>

          <div class="product-desc">{{ item.description || `含 ${item.exportCount} 次导出` }}</div>

        </div>

        <el-button type="primary" size="small" :loading="ordering && activeProductId === item.id" @click="startPay(item)">

          ¥{{ formatPrice(item.price) }}

        </el-button>

      </div>

      <el-empty v-if="!products.length" description="暂无商品" :image-size="56" />

    </div>

    <div v-else-if="payStep === 'pay'">

      <p class="pay-tip">{{ orderInfo.productName }} · ¥{{ formatPrice(orderInfo.amount) }}</p>

      <div v-if="orderInfo.mockPay" class="mock-pay-box">

        <p>当前为<strong>模拟支付</strong>（未配置支付宝商户）。点击下方按钮完成测试支付。</p>

        <el-button type="primary" :loading="confirming" @click="confirmMockPay">模拟支付成功</el-button>

      </div>

      <div v-else class="page-pay-box">

        <p class="page-pay-tip">已打开支付宝收银台，请在新窗口中<strong>扫码或登录</strong>完成付款。</p>

        <p v-if="popupBlocked" class="popup-blocked">浏览器拦截了弹窗，请点击下方按钮手动打开。</p>

        <el-button type="primary" @click="openPayPage">重新打开支付宝收银台</el-button>

        <p v-if="polling" class="polling-tip">等待支付结果...</p>

      </div>

    </div>

  </el-dialog>

</template>



<script>

import {

  fetchExportProducts,

  createExportPayOrder,

  fetchExportOrderStatus,

  mockConfirmExportPay

} from '../utils/teacherExportBilling'



export default {

  name: 'HandoutExportPayDialog',

  props: {

    visible: { type: Boolean, default: false }

  },

  data() {

    return {

      innerVisible: false,

      loading: false,

      ordering: false,

      confirming: false,

      polling: false,

      popupBlocked: false,

      payStep: 'choose',

      products: [],

      activeProductId: null,

      orderInfo: {},

      pollTimer: null

    }

  },

  watch: {

    visible: {

      immediate: true,

      handler(val) {

        this.innerVisible = val

        if (val) this.openDialog()

      }

    },

    innerVisible(val) {

      this.$emit('update:visible', val)

    }

  },

  beforeDestroy() {

    this.stopPolling()

  },

  methods: {

    formatPrice(price) {

      const n = Number(price)

      return Number.isFinite(n) ? n.toFixed(2) : price

    },

    async openDialog() {

      this.payStep = 'choose'

      this.loading = true

      try {

        this.products = await fetchExportProducts() || []

      } catch (e) {

        this.products = []

      } finally {

        this.loading = false

      }

    },

    openPayPage() {

      const url = this.orderInfo && this.orderInfo.payUrl

      if (!url) return

      const win = window.open(url, '_blank')

      this.popupBlocked = !win

    },

    async startPay(product) {

      this.ordering = true

      this.activeProductId = product.id

      try {

        const data = await createExportPayOrder(product.id)

        this.orderInfo = data || {}

        this.payStep = 'pay'

        if (data && data.mockPay) {

          return

        }

        this.popupBlocked = false

        this.openPayPage()

        if (data && data.orderNo) {

          this.startPolling(data.orderNo)

        }

      } catch (e) {

        this.$message.error('创建订单失败')

      } finally {

        this.ordering = false

        this.activeProductId = null

      }

    },

    async confirmMockPay() {

      if (!this.orderInfo.orderNo) return

      this.confirming = true

      try {

        await mockConfirmExportPay(this.orderInfo.orderNo)

        this.$message.success('支付成功，导出次数已到账')

        this.$emit('paid')

        this.innerVisible = false

      } catch (e) {

        this.$message.error('模拟支付失败')

      } finally {

        this.confirming = false

      }

    },

    startPolling(orderNo) {

      this.stopPolling()

      this.polling = true

      this.pollTimer = setInterval(async () => {

        try {

          const status = await fetchExportOrderStatus(orderNo)

          if (status && status.paid) {

            this.stopPolling()

            this.$message.success('支付成功，导出次数已到账')

            this.$emit('paid')

            this.innerVisible = false

          }

        } catch (e) {}

      }, 2500)

    },

    stopPolling() {

      if (this.pollTimer) {

        clearInterval(this.pollTimer)

        this.pollTimer = null

      }

      this.polling = false

    },

    resetState() {

      this.stopPolling()

      this.payStep = 'choose'

      this.orderInfo = {}

      this.popupBlocked = false

    }

  }

}

</script>



<style scoped>

.pay-tip { margin: 0 0 12px; color: #6b7280; font-size: 13px; line-height: 1.6; }

.product-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f0f2f5; }

.product-name { font-weight: 600; color: #1f2937; }

.product-desc { font-size: 12px; color: #9ca3af; margin-top: 4px; }

.mock-pay-box, .page-pay-box { text-align: center; padding: 8px 0 4px; }

.page-pay-tip { margin: 0 0 12px; color: #374151; font-size: 13px; line-height: 1.7; }

.popup-blocked { margin: 0 0 10px; color: #e6a23c; font-size: 12px; }

.polling-tip { margin-top: 12px; font-size: 13px; color: #6b7280; }

.pay-loading { text-align: center; color: #9ca3af; padding: 24px 0; }

</style>

